import WeeksEdit from './WeeksEdit'

export default WeeksEdit
